// Shared category options for tennis competitions
export const CATEGORY_OPTIONS = [
    { value: 'ATP', label: 'ATP' },
    { value: 'Billie Jean King Cup', label: 'Billie Jean King Cup' },
    { value: 'Challenger', label: 'Challenger' },
    { value: 'Davis Cup', label: 'Davis Cup' },
    { value: 'Exhibition', label: 'Exhibition' },
    { value: 'ITF Men', label: 'ITF Men' },
    { value: 'ITF Women', label: 'ITF Women' },
    { value: 'UTR Men', label: 'UTR Men' },
    { value: 'UTR Women', label: 'UTR Women' },
    { value: 'WTA', label: 'WTA' },
    { value: 'WTA 125K', label: 'WTA 125K' },
] as const

export type Category = typeof CATEGORY_OPTIONS[number]['value']

// Gender options for competitions
export const GENDER_OPTIONS = [
    { value: 'men', label: 'Men' },
    { value: 'women', label: 'Women' },
    { value: 'mixed', label: 'Mixed' },
] as const

export type Gender = typeof GENDER_OPTIONS[number]['value']

// Type options for competitions (singles vs doubles)
export const TYPE_OPTIONS = [
    { value: 'singles', label: 'Singles' },
    { value: 'doubles', label: 'Doubles' },
    { value: 'mixed', label: 'Mixed' },
] as const

export type CompetitionType = typeof TYPE_OPTIONS[number]['value']
